import styled from '@emotion/styled';
import * as React from 'react';
import { ReactTelephoneInput } from 'react-telephone-input';
import { FormInputProps } from '../form-input/FormInput';

type Event = React.ChangeEvent<any>;

const formatE164 = (tel: string) => tel.replace(/[()-]/g, '');

// XXX: !importants due to hyper-specific syling in react-telephone-input.
// 	    otherwise very very difficult to override styles.
const InputWrapper = styled.div<{ valid: string }>`
	input {
		${(props) => props.valid === 'true' ? '' : ' \
			background: #fff2f5 !important; \
			border: 1px #972f48 solid !important; \
			outline: 1px solid #972f48; '
	}

	.selected-flag {
		${(props) => props.valid === 'true' ? '' : ' \
			border: 1px #972f48 solid !important;'
	}

	.react-tel-input:focus-within  {
		${(props) => props.valid === 'true' ? '' : ' \
			background: #fff2f5 !important; \
			border: 1px #972f48 solid !important; \
			outline: 1px solid #972f48 !important;  '}
`;

export const FormInputPhone = (props: FormInputProps) => {
	const onChange = (value: string) => props.onChange &&
		props.onChange({ target: { value: formatE164(value) } } as Event);

	const rtiProps = {
		defaultCountry: 'gb',
		preferredCountries: ['gb', 'ie', 'fr', 'es', 'it', 'gr', 'us'],
		flagsImagePath: '/71eb904/assets/images/flags.png',
		initialValue: props.value || '',
		onChange
	};

	return <div className={`form-input-phone__wrapper`}>
		<InputWrapper valid={props['is-valid']}>
			<ReactTelephoneInput {...rtiProps} />
		</InputWrapper>
	</div>;
};
